export default function Plus(props) {
	return (
		<svg width={props.width} height={props.height} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
	);
}